import React from "react";

export const CuposItem = React.memo((props) => (
  <div className="cupos-appointment-item">
    {props.data.Quotas.map((item) => (
      <span className={`item-${item.Quota.Id}`} key={item.Quota.Description + item.Quota.Id}>{`${item.AmmountQuota} + ${item.AmmountOverQuota}`}</span>
    ))}
  </div>
));
